import app from './Vue/app';
import { defineAsyncComponent } from 'vue';
import HomeCarousel from './Vue/Components/home/HomeCarousel.vue';
import ScrollController from './Vue/Components/home/ScrollController.vue';
import BlogCarousel from './Vue/Components/home/blogCarousel.vue';

const Water = defineAsyncComponent(() => import('./Vue/Components/water.vue'));
const Flavorite = defineAsyncComponent(() => import('./Vue/Components/home/Flavorite.vue'));
const BottleCatch = defineAsyncComponent(() => import('./Vue/Components/home/bottleCatch.vue'));

app.component('ScrollController', ScrollController);
app.component('Water', Water);
app.component('HomeCarousel', HomeCarousel);
app.component('BlogCarousel', BlogCarousel);
app.component('Flavorite', Flavorite);
app.component('BottleCatch', BottleCatch);
